var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcFb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "30px",
    viewBox: "0 0 31 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_fb") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Winds-Webapp",
    transform: "translate(-252.000000, -8608.000000)",
    fill: "#ADADB2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(0.000000, 8145.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(252.000000, 463.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0770988,0 C6.75042833,0 0,6.75042833 0,15.0770988 C0,22.6362079 5.56824672,28.8774415 12.8237579,29.9677898 L12.8237579,19.0732153 L9.09354654,19.0732153 L9.09354654,15.1099943 L12.8237579,15.1099943 L12.8237579,12.4728726 C12.8237579,8.1066819 14.9509994,6.18983438 18.579783,6.18983438 C20.3177613,6.18983438 21.236779,6.31867504 21.6719589,6.37761279 L21.6719589,9.83712164 L19.1965734,9.83712164 C17.655968,9.83712164 17.1179897,11.2975443 17.1179897,12.9436893 L17.1179897,15.1099943 L21.6328955,15.1099943 L21.020217,19.0732153 L17.1179897,19.0732153 L17.1179897,30 C24.4769846,29.0014849 30.1541976,22.7095374 30.1541976,15.0770988 C30.1541976,6.75042833 23.4037693,0 15.0770988,0 Z",
    id: "ic_fb"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFb);
export default __webpack_public_path__ + "static/media/ic_fb.a17129fd5a1f863c651ff731315b5ebc.svg";
export { ForwardRef as ReactComponent };